import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

export const authGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const cookieService = inject(CookieService);
  const router = inject(Router);

  if (cookieService.check('token')) {
    return true;
  }

  // Preserve job application context when redirecting from jobboard apply route
  const urlTree = router.parseUrl(state.url);
  const segments = urlTree.root.children['primary']?.segments ?? [];
  const isJobboardApply =
    segments[0]?.path === 'jobboard' && segments[1]?.path === 'apply';

  if (isJobboardApply) {
    const jobId = segments[2]?.path;
    const qp = urlTree.queryParams;
    const loginParams: any = {};
    if (jobId) {
      loginParams['service'] = 'applyjob';
      loginParams['applyjob'] = jobId;
    }
    if (qp['location']) loginParams['location'] = qp['location'];
    if (qp['source'])   loginParams['source']   = qp['source'];
    return router.createUrlTree(['/login'], { queryParams: loginParams });
  }

  localStorage.setItem('returnUrl', state.url);
  return router.createUrlTree(['/login']);
};
